import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/core/services/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  standalone: false
})
export class ItemComponent implements OnInit {
  breadCrumbItems!: Array<{}>;
  itemForm!: UntypedFormGroup;
  submitted = false;
  showForm = false;
  isEditMode = false;
  editId: any = null;

  Items: any[] = [];
  categories: any[] = [];
  units: any[] = [];
  totalItems: any;
  isLoading = false;

  // Pagination
  page = 1;
  pageSize = 5;

  constructor(
    private fb: UntypedFormBuilder,
    private api: ApiService
  ) {}

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'Inventory' },
      { label: 'Items', active: true }
    ];
    this.initializeForm();
    this.loadItems();
    this.loadCategories();
    this.loadUnits();
  }

  initializeForm(): void {
    this.itemForm = this.fb.group({
      name: ['', Validators.required],
      code: ['', Validators.required],
      category_id: ['', Validators.required],
      unit_id: ['', Validators.required],
      gst_rate: [0, [Validators.required, Validators.min(0)]],
      hsn_code: ['', Validators.required],
      minimum_stock: [0, [Validators.required, Validators.min(0)]],
      current_stock: [0],
      is_active: [true]
    });
  }

  get f() { return this.itemForm.controls; }

  toggleForm(): void {
    this.showForm = !this.showForm;
    if (!this.showForm) this.resetForm();
  }

  resetForm(): void {
    this.submitted = false;
    this.isEditMode = false;
    this.editId = null;
    this.itemForm.reset({
      gst_rate: 0,
      minimum_stock: 0,
      current_stock: 0,
      is_active: true
    });
  }

  loadItems(): void {
  this.isLoading = true;
  this.api.get(`/items?page=${this.page}&limit=${this.pageSize}`).subscribe({
    next: (res: any) => {
      this.isLoading = false;
      if (res.success) {
        this.Items = res.data || [];
        this.totalItems = Number(res.total) || 0;
        this.pageSize = Number(res.perPage) || this.pageSize;
        this.page = Number(res.currentPage) || this.page;
      }
    },
    error: () => (this.isLoading = false)
  });
}

  loadCategories(): void {
    this.api.get('/categories').subscribe({
      next: (res: any) => {
        if (res.success) this.categories = res.data;
      }
    });
  }

  loadUnits(): void {
    this.api.get('/units').subscribe({
      next: (res: any) => {
        if (res.success) this.units = res.data;
      }
    });
  }

  saveItem(): void {
    this.submitted = true;
    if (this.itemForm.invalid) return;

    const payload = this.itemForm.value;
    const apiCall = this.isEditMode
      ? this.api.put(`/items/${this.editId}`, payload)
      : this.api.post('/items', payload);

    apiCall.subscribe({
      next: (res: any) => {
        if (res.success) {
          Swal.fire('Success', this.isEditMode ? 'Item updated!' : 'Item created!', 'success');
          this.toggleForm();
          this.loadItems();
        }
      }
    });
  }

  editItem(item: any): void {
    this.showForm = true;
    this.isEditMode = true;
    this.editId = item.id;
    this.itemForm.patchValue(item);
  }

  deleteItem(id: number): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    }).then(result => {
      if (result.isConfirmed) {
        this.api.delete(`/items/${id}`).subscribe({
          next: (res: any) => {
            if (res.success) {
              Swal.fire('Deleted!', 'Item deleted successfully', 'success');
              this.loadItems();
            }
          }
        });
      }
    });
  }

  changePage(page: number): void {
    this.page = page;
    this.loadItems();
  }

  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }
}
